(function ($) {

    // Redireciona o visitante pro WhatsApp depois do envio do formulário.
    // - No wpcf7mailsent monta a mensagem com os dados enviados e guarda na sessão
    // - Na página de Sucesso lê a mensagem e manda pro wa.me
    //
    // A mensagem viaja em sessionStorage, e não na URL, pra não deixar dado
    // pessoal no histórico do navegador nem no referrer do wa.me.
    //
    // Depende de: jQuery, mpWa (localizado pelo PHP).

    var STORAGE_KEY = 'mpWaMessage';
    var MAX_LENGTH  = 1200;
    var SELECTOR_BOX = '.wa-redirect';

    // Fallback pra quando o sessionStorage está indisponível (aba anônima).
    // Só serve dentro da mesma página; o redirect da tela de Sucesso depende
    // do storage, então nesse caso o visitante usa o botão manual.
    var memory = null;

    function config() {
        return (typeof window.mpWa !== 'undefined' && window.mpWa) ? window.mpWa : null;
    }

    function clean(value) {
        return String(value == null ? '' : value)
            .replace(/\s+/g, ' ')
            .replace(/^\s+|\s+$/g, '');
    }

    // O CF7 6.x entrega os dados enviados em event.detail.inputs — usar isso
    // evita a corrida com o reset do form, que acontece logo depois do evento.
    function inputsToMap(inputs) {
        var map = {};
        if (!inputs || !inputs.length) return map;

        for (var i = 0; i < inputs.length; i++) {
            var input = inputs[i];
            if (!input || !input.name) continue;
            if (typeof input.value !== 'string') continue;

            var name = input.name;
            var val  = clean(input.value);
            if (val === '') continue;

            // Radio/checkbox repetem a chave; mantém o primeiro valor marcado
            if (!map[name]) map[name] = val;
        }

        return map;
    }

    function formToMap($form) {
        var map = {};

        $form.find('input, select, textarea').each(function () {
            var $field = $(this);
            var name   = $field.attr('name');
            var type   = ($field.attr('type') || '').toLowerCase();

            if (!name || name.charAt(0) === '_') return;
            if (type === 'submit' || type === 'button') return;
            if ((type === 'radio' || type === 'checkbox') && !$field.is(':checked')) return;

            var val = clean($field.val());
            if (val === '' || map[name]) return;

            map[name] = val;
        });

        return map;
    }

    function buildMessage(map) {
        var cfg = config();
        if (!cfg || !cfg.fields || !cfg.fields.length) return '';

        var isPJ  = (map[cfg.typeField] || '') === cfg.typePj;
        var parts = [];

        for (var i = 0; i < cfg.fields.length; i++) {
            var field = cfg.fields[i];
            var mode  = field.mode || 'any';

            if (mode === 'pj' && !isPJ) continue;
            if (mode === 'pf' && isPJ) continue;

            var value = map[field.name];
            if (!value) continue;

            // Campo com limite próprio (textarea): corta aqui pra não comer o
            // sufixo "Vim da página X" no corte final da mensagem
            if (field.max && value.length > field.max) {
                value = value.substring(0, field.max) + '...';
            }

            parts.push(field.label + ': ' + value);
        }

        if (!parts.length) return '';

        var message = parts.join(', ');
        var title   = clean(cfg.pageTitle);

        if (title !== '' && cfg.suffix) {
            message += ' - ' + cfg.suffix.replace('%s', title);
        }

        return message.substring(0, MAX_LENGTH);
    }

    function store(message) {
        memory = message;
        try {
            window.sessionStorage.setItem(STORAGE_KEY, message);
        } catch (e) {}
    }

    function retrieve() {
        try {
            var raw = window.sessionStorage.getItem(STORAGE_KEY);
            if (raw) return raw;
        } catch (e) {}
        return memory;
    }

    function forget() {
        memory = null;
        try {
            window.sessionStorage.removeItem(STORAGE_KEY);
        } catch (e) {}
    }

    function whatsappLink(message) {
        var cfg = config();
        if (!cfg || !cfg.number) return '';
        return 'https://wa.me/' + cfg.number + '?text=' + encodeURIComponent(message);
    }

    // Ponta A — na página do formulário: guarda a mensagem antes de sair
    function captureOnSent() {
        document.addEventListener('wpcf7mailsent', function (event) {
            var map = {};

            if (event && event.detail && event.detail.inputs) {
                map = inputsToMap(event.detail.inputs);
            }

            // Instalação antiga do CF7, sem detail.inputs: lê o form direto.
            // O reset só ocorre depois deste handler, então os valores ainda estão lá.
            if ($.isEmptyObject(map) && event && event.target) {
                map = formToMap($(event.target));
            }

            var message = buildMessage(map);
            if (message !== '') store(message);
        }, false);
    }

    // Ponta B — na página de Sucesso: revela o aviso e redireciona
    function redirectOnSuccess() {
        var cfg     = config();
        var message = retrieve();

        if (!message) return;

        var link = whatsappLink(message);

        // Chegou na tela de Sucesso mas mp_whatsapp está vazio: mantém a tela como estava
        if (link === '') {
            forget();
            return;
        }

        var $box = $(SELECTOR_BOX);
        if ($box.length) {
            $box.find('.wa-redirect_link').attr('href', link);
            $box.removeAttr('hidden');
        }

        // Some do storage antes de navegar: um F5 na tela de Sucesso não
        // pode reenviar o visitante pro WhatsApp de novo
        forget();

        window.setTimeout(function () {
            window.location.href = link;
        }, (cfg && cfg.delay) || 1200);
    }

    $(function () {
        var cfg = config();
        if (!cfg) return;

        if (cfg.isSuccess) {
            redirectOnSuccess();
            return;
        }

        captureOnSent();
    });

})(jQuery);
